import { render, staticRenderFns } from "./historyTable.vue?vue&type=template&id=e8a78ae6&scoped=true&"
import script from "./historyTable.vue?vue&type=script&lang=js&"
export * from "./historyTable.vue?vue&type=script&lang=js&"
import style0 from "./historyTable.vue?vue&type=style&index=0&id=e8a78ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a78ae6",
  null
  
)

export default component.exports